"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeOptionsFromOrderMutation = exports.addOptionsToOrderMutation = void 0;
const fragments_1 = require("../../types/next/fragments");
exports.addOptionsToOrderMutation = `
  mutation addOptionsToOrder($orderId: ID!, $options: [VehicleOptionInput!]) {
    addOptionsToOrder(orderId: $orderId, options: $options) {
      ...order
    }
  }
  ${fragments_1.orderFragments}
`;
exports.removeOptionsFromOrderMutation = `
  mutation removeOptionsFromOrder($orderId: ID!, $options: [VehicleOptionInput!]) {
    removeOptionsFromOrder(orderId: $orderId, options: $options) {
      ...order
    }
  }
  ${fragments_1.orderFragments}
`;
//# sourceMappingURL=option.js.map